/**
 * @generated SignedSource<<95ffa36c4b81a59cc0edaf98ef22e365>>
 * @relayHash 19ef944050261dca05d1e4776d2189ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1c2c34c22dc031047a0af91c796ad21b1718bec2d8c95bab0366a0fbb16141b0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SoftwareCapacityContainerBoardFilterQuery } from './SoftwareCapacityContainerBoardFilterQuery.graphql';

const node: PreloadableConcreteRequest<SoftwareCapacityContainerBoardFilterQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1c2c34c22dc031047a0af91c796ad21b1718bec2d8c95bab0366a0fbb16141b0",
    "metadata": {},
    "name": "SoftwareCapacityContainerBoardFilterQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
